/**
 * Vitre dépolie sous la barre de statut iOS : le contenu qui défile se fond
 * sous l'horloge au lieu de la traverser net (patron Messages/Mail). Rendue
 * une seule fois dans App ; inerte sur le web (`display: none` sans la classe
 * `is-native` sur <html> — voir lib/platform/native-class.ts). Purement
 * décorative : aucun toucher intercepté, invisible pour l'accessibilité.
 * Styles : .statusbar-scrim dans global.css (DS §6.7).
 */
export function StatusBarScrim() {
  return <div className="statusbar-scrim" aria-hidden="true" />;
}
